import React from 'react';
import Icon from '../../../components/AppIcon';

const VersionControl = ({ content, onClose }) => {
  const versionHistory = [
    {
      version: '2.1',
      date: '11/15/2025',
      author: 'Sarah Johnson',
      changes: 'Updated emergency contact procedures and added new safety equipment section',
      status: 'current'
    },
    {
      version: '2.0',
      date: '10/01/2025',
      author: 'Mike Chen',
      changes: 'Major revision: Restructured content flow and added interactive elements',
      status: 'archived'
    },
    {
      version: '1.5',
      date: '08/15/2025',
      author: 'Sarah Johnson',
      changes: 'Minor updates to PPE requirements and compliance guidelines',
      status: 'archived'
    }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h3 className="text-xl font-semibold text-foreground mb-1">Version Control</h3>
          <p className="text-sm text-muted-foreground">{content?.title}</p>
        </div>
        <button
          onClick={onClose}
          className="p-2 hover:bg-muted rounded-lg transition-colors"
        >
          <Icon name="X" size={20} />
        </button>
      </div>
      <div className="space-y-4">
        {versionHistory?.map((version, index) => (
          <div
            key={index}
            className={`p-4 rounded-lg border ${
              version?.status === 'current' ?'border-primary/20 bg-primary/5' :'border-border bg-muted/50'
            }`}
          >
            <div className="flex items-start justify-between mb-3">
              <div className="flex items-center gap-3">
                <span className={`px-3 py-1 rounded-full text-sm font-semibold ${
                  version?.status === 'current' ?'bg-primary/10 text-primary' :'bg-muted text-muted-foreground'
                }`}>
                  v{version?.version}
                </span>
                {version?.status === 'current' && (
                  <span className="px-2 py-0.5 bg-success/10 text-success text-xs font-medium rounded-full">
                    Current
                  </span>
                )}
              </div>
              <div className="flex items-center gap-2">
                <button className="p-1.5 hover:bg-background rounded transition-colors">
                  <Icon name="Download" size={16} className="text-muted-foreground" />
                </button>
                <button className="p-1.5 hover:bg-background rounded transition-colors">
                  <Icon name="Eye" size={16} className="text-muted-foreground" />
                </button>
                {version?.status !== 'current' && (
                  <button className="p-1.5 hover:bg-background rounded transition-colors">
                    <Icon name="RotateCcw" size={16} className="text-muted-foreground" />
                  </button>
                )}
              </div>
            </div>
            <p className="text-sm text-foreground mb-2">{version?.changes}</p>
            <div className="flex items-center gap-4 text-xs text-muted-foreground">
              <span className="flex items-center gap-1">
                <Icon name="User" size={12} />
                {version?.author}
              </span>
              <span className="flex items-center gap-1">
                <Icon name="Calendar" size={12} />
                {version?.date}
              </span>
            </div>
          </div>
        ))}
      </div>
      <div className="mt-6 pt-6 border-t border-border">
        <button className="w-full flex items-center justify-center gap-2 px-4 py-3 bg-primary text-primary-foreground rounded-lg hover:bg-primary/90 transition-colors font-medium">
          <Icon name="Upload" size={18} />
          Upload New Version
        </button>
      </div>
    </div>
  );
};

export default VersionControl;